import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "kpi-admin" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  colspan: "7",
  class: "text-center py-4"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  colspan: "5",
  class: "text-center py-4"
}
const _hoisted_6 = { class: "d-flex align-center gap-2" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  colspan: "6",
  class: "text-center py-4"
}
const _hoisted_9 = { class: "d-flex align-center gap-2" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex justify-center py-6"
}
const _hoisted_11 = {
  key: 1,
  class: "text-center text-grey py-4"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "d-flex align-center gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_tabs, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
      color: _ctx.APP_Color,
      class: "mb-4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "definitii" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-1"
            }, {
              default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                _createTextVNode("mdi-cog", -1)
              ]))]),
              _: 1
            }),
            _cache[34] || (_cache[34] = _createTextVNode(" Definiții KPI ", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "agenti" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-1"
            }, {
              default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                _createTextVNode("mdi-account-group", -1)
              ]))]),
              _: 1
            }),
            _cache[36] || (_cache[36] = _createTextVNode(" Roluri Agenți ", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "targete" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-1"
            }, {
              default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                _createTextVNode("mdi-target-variant", -1)
              ]))]),
              _: 1
            }),
            _cache[38] || (_cache[38] = _createTextVNode(" Targete Individuale ", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "echipa" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-1"
            }, {
              default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                _createTextVNode("mdi-chart-bar", -1)
              ]))]),
              _: 1
            }),
            _cache[40] || (_cache[40] = _createTextVNode(" Raport Echipă ", -1))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "color"]),
    _createVNode(_component_v_window, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.activeTab) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "definitii" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              elevation: "2",
              class: "admin-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "card-title-row" }, {
                  default: _withCtx(() => [
                    _cache[43] || (_cache[43] = _createElementVNode("span", null, "Definiții KPI", -1)),
                    _createVNode(_component_v_btn, {
                      color: _ctx.APP_Color,
                      size: "small",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDefinitieDialog()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: "16",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                            _createTextVNode("mdi-plus", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[42] || (_cache[42] = _createTextVNode(" Adaugă ", -1))
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "pa-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_table, { class: "admin-table" }, {
                      default: _withCtx(() => [
                        _cache[46] || (_cache[46] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Cod"),
                            _createElementVNode("th", null, "Denumire"),
                            _createElementVNode("th", null, "Tip Agent"),
                            _createElementVNode("th", null, "Target Lunar"),
                            _createElementVNode("th", null, "Tip Calcul"),
                            _createElementVNode("th", null, "Activ"),
                            _createElementVNode("th", null, "Acțiuni")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_ctx.loadingDefinitii)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
                                _createElementVNode("td", _hoisted_3, [
                                  _createVNode(_component_v_progress_circular, {
                                    indeterminate: "",
                                    color: _ctx.APP_Color,
                                    size: "24"
                                  }, null, 8, ["color"])
                                ])
                              ]))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.definitii, (def) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: def.ID
                                }, [
                                  _createElementVNode("td", null, [
                                    _createElementVNode("code", null, _toDisplayString(def.Cod), 1)
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(def.Denumire), 1),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_v_chip, {
                                      color: def.TipAgent === 'Hunter' ? 'deep-orange' : def.TipAgent === 'Farmer' ? 'green' : 'blue',
                                      size: "x-small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(def.TipAgent), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color"])
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(def.TargetLunarDefault), 1),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_v_chip, {
                                      color: def.TipCalcul === 'Automat' ? 'blue' : 'grey',
                                      size: "x-small",
                                      variant: "tonal"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(def.TipCalcul), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_v_icon, {
                                      color: def.IsActiv ? 'green' : 'grey',
                                      size: "18"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(def.IsActiv ? 'mdi-check-circle' : 'mdi-close-circle'), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color"])
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_v_btn, {
                                      icon: "",
                                      size: "x-small",
                                      variant: "text",
                                      onClick: ($event: any) => (_ctx.openDefinitieDialog(def))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "16" }, {
                                          default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                            _createTextVNode("mdi-pencil", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]),
                                    _createVNode(_component_v_btn, {
                                      icon: "",
                                      size: "x-small",
                                      variant: "text",
                                      color: "error",
                                      onClick: ($event: any) => (_ctx.deleteDefinitie(def))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "16" }, {
                                          default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                            _createTextVNode("mdi-delete", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ]))
                              }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "agenti" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              elevation: "2",
              class: "admin-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "card-title-row" }, {
                  default: _withCtx(() => [
                    _cache[49] || (_cache[49] = _createElementVNode("span", null, "Roluri Agenți (Hunter / Farmer)", -1)),
                    _createVNode(_component_v_btn, {
                      color: _ctx.APP_Color,
                      size: "small",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openAgentDialog()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: "16",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                            _createTextVNode("mdi-plus", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[48] || (_cache[48] = _createTextVNode(" Adaugă ", -1))
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "pa-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_table, { class: "admin-table" }, {
                      default: _withCtx(() => [
                        _cache[52] || (_cache[52] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Utilizator"),
                            _createElementVNode("th", null, "Tip Agent"),
                            _createElementVNode("th", null, "Data Start"),
                            _createElementVNode("th", null, "Data End"),
                            _createElementVNode("th", null, "Acțiuni")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_ctx.loadingAgenti)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                                _createElementVNode("td", _hoisted_5, [
                                  _createVNode(_component_v_progress_circular, {
                                    indeterminate: "",
                                    color: _ctx.APP_Color,
                                    size: "24"
                                  }, null, 8, ["color"])
                                ])
                              ]))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.agenti, (agent) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: agent.ID
                                }, [
                                  _createElementVNode("td", null, _toDisplayString(agent.Utilizator), 1),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_v_chip, {
                                      color: agent.TipAgent === 'Hunter' ? 'deep-orange' : 'green',
                                      size: "x-small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(agent.TipAgent), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color"])
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(agent.DataStart)), 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(agent.DataEnd) || '—'), 1),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_v_btn, {
                                      icon: "",
                                      size: "x-small",
                                      variant: "text",
                                      onClick: ($event: any) => (_ctx.openAgentDialog(agent))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "16" }, {
                                          default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                            _createTextVNode("mdi-pencil", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]),
                                    _createVNode(_component_v_btn, {
                                      icon: "",
                                      size: "x-small",
                                      variant: "text",
                                      color: "error",
                                      onClick: ($event: any) => (_ctx.deleteAgent(agent))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "16" }, {
                                          default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                            _createTextVNode("mdi-delete", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ]))
                              }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "targete" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              elevation: "2",
              class: "admin-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "card-title-row" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _cache[53] || (_cache[53] = _createElementVNode("span", null, "Targete Individuale", -1)),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.targetAn,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.targetAn) = $event)),
                          _ctx.incarcaTargete
                        ],
                        items: _ctx.ani,
                        density: "compact",
                        variant: "outlined",
                        "hide-details": "",
                        class: "filter-select ml-3"
                      }, null, 8, ["modelValue", "items", "onUpdate:modelValue"]),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.targetLuna,
                        "onUpdate:modelValue": [
                          _cache[4] || (_cache[4] = ($event: any) => ((_ctx.targetLuna) = $event)),
                          _ctx.incarcaTargete
                        ],
                        items: _ctx.luni,
                        "item-title": "label",
                        "item-value": "value",
                        density: "compact",
                        variant: "outlined",
                        "hide-details": "",
                        class: "filter-select ml-2"
                      }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
                    ]),
                    _createVNode(_component_v_btn, {
                      color: _ctx.APP_Color,
                      size: "small",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openTargetDialog()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: "16",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                            _createTextVNode("mdi-plus", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[55] || (_cache[55] = _createTextVNode(" Adaugă Override ", -1))
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "pa-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_table, { class: "admin-table" }, {
                      default: _withCtx(() => [
                        _cache[58] || (_cache[58] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Utilizator"),
                            _createElementVNode("th", null, "KPI"),
                            _createElementVNode("th", null, "An"),
                            _createElementVNode("th", null, "Lună"),
                            _createElementVNode("th", null, "Target Override"),
                            _createElementVNode("th", null, "Acțiuni")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_ctx.loadingTargete)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                                _createElementVNode("td", _hoisted_8, [
                                  _createVNode(_component_v_progress_circular, {
                                    indeterminate: "",
                                    color: _ctx.APP_Color,
                                    size: "24"
                                  }, null, 8, ["color"])
                                ])
                              ]))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.targete, (t) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: t.ID
                                }, [
                                  _createElementVNode("td", null, _toDisplayString(t.Utilizator), 1),
                                  _createElementVNode("td", null, _toDisplayString(t.KPIDefinitie?.Denumire || t.KPIDefinitieID), 1),
                                  _createElementVNode("td", null, _toDisplayString(t.An), 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.numeleLunii(t.Luna)), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("strong", null, _toDisplayString(t.Target), 1)
                                  ]),
                                  _createElementVNode("td", null, [
                                    _createVNode(_component_v_btn, {
                                      icon: "",
                                      size: "x-small",
                                      variant: "text",
                                      onClick: ($event: any) => (_ctx.openTargetDialog(t))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "16" }, {
                                          default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                            _createTextVNode("mdi-pencil", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"]),
                                    _createVNode(_component_v_btn, {
                                      icon: "",
                                      size: "x-small",
                                      variant: "text",
                                      color: "error",
                                      onClick: ($event: any) => (_ctx.deleteTarget(t))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { size: "16" }, {
                                          default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                            _createTextVNode("mdi-delete", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ]))
                              }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "echipa" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              elevation: "2",
              class: "admin-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "card-title-row" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[59] || (_cache[59] = _createElementVNode("span", null, "Raport KPI Echipă", -1)),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.echipaAn,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.echipaAn) = $event)),
                        items: _ctx.ani,
                        density: "compact",
                        variant: "outlined",
                        "hide-details": "",
                        class: "filter-select ml-3"
                      }, null, 8, ["modelValue", "items"]),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.echipaLuna,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.echipaLuna) = $event)),
                        items: _ctx.luni,
                        "item-title": "label",
                        "item-value": "value",
                        density: "compact",
                        variant: "outlined",
                        "hide-details": "",
                        class: "filter-select ml-2"
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _createVNode(_component_v_btn, {
                      color: _ctx.APP_Color,
                      size: "small",
                      loading: _ctx.loadingEchipa,
                      onClick: _ctx.incarcaEchipa
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          size: "16",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                            _createTextVNode("mdi-refresh", -1)
                          ]))]),
                          _: 1
                        }),
                        _cache[61] || (_cache[61] = _createTextVNode(" Încarcă ", -1))
                      ]),
                      _: 1
                    }, 8, ["color", "loading", "onClick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    (_ctx.loadingEchipa)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_v_progress_circular, {
                            indeterminate: "",
                            color: _ctx.APP_Color,
                            size: "40"
                          }, null, 8, ["color"])
                        ]))
                      : (_ctx.echipaData.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Apăsați „Încarcă\" pentru a vedea raportul echipei. "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_component_v_expansion_panels, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.echipaData, (member) => {
                                  return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                    key: member.Utilizator
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_expansion_panel_title, null, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_13, [
                                            _createVNode(_component_v_icon, { size: "18" }, {
                                              default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                                                _createTextVNode("mdi-account", -1)
                                              ]))]),
                                              _: 1
                                            }),
                                            _createElementVNode("strong", null, _toDisplayString(member.Utilizator), 1),
                                            _createVNode(_component_v_chip, {
                                              color: member.TipAgent === 'Hunter' ? 'deep-orange' : 'green',
                                              size: "x-small"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(member.TipAgent), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["color"]),
                                            _createVNode(_component_v_chip, {
                                              size: "x-small",
                                              color: _ctx.medieMemberColor(member.KPIs),
                                              variant: "tonal"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.medieMember(member.KPIs)) + "% medie ", 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["color"])
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_expansion_panel_text, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_table, { density: "compact" }, {
                                            default: _withCtx(() => [
                                              _cache[63] || (_cache[63] = _createElementVNode("thead", null, [
                                                _createElementVNode("tr", null, [
                                                  _createElementVNode("th", null, "KPI"),
                                                  _createElementVNode("th", null, "Target"),
                                                  _createElementVNode("th", null, "Realizat"),
                                                  _createElementVNode("th", null, "%")
                                                ])
                                              ], -1)),
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(member.KPIs, (kpi) => {
                                                  return (_openBlock(), _createElementBlock("tr", {
                                                    key: kpi.KPIDefinitieID
                                                  }, [
                                                    _createElementVNode("td", null, _toDisplayString(kpi.Denumire), 1),
                                                    _createElementVNode("td", null, _toDisplayString(kpi.Target), 1),
                                                    _createElementVNode("td", {
                                                      style: _normalizeStyle({ color: _ctx.getKPIColor(kpi.ProcentRealizat), fontWeight: '700' })
                                                    }, _toDisplayString(kpi.Realizat), 5),
                                                    _createElementVNode("td", null, [
                                                      _createVNode(_component_v_chip, {
                                                        color: _ctx.kpiChipColor(kpi.ProcentRealizat),
                                                        size: "x-small",
                                                        label: ""
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(kpi.ProcentRealizat) + "% ", 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["color"])
                                                    ])
                                                  ]))
                                                }), 128))
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.definitieDialog,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.definitieDialog) = $event)),
      "max-width": "560"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.definitieForm.ID ? 'Editare' : 'Adăugare') + " Definiție KPI", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { dense: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.definitieForm.Cod,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.definitieForm.Cod) = $event)),
                          label: "Cod (unic)",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.definitieForm.TipAgent,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.definitieForm.TipAgent) = $event)),
                          items: ['Hunter', 'Farmer', 'Ambele'],
                          label: "Tip Agent",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.definitieForm.Denumire,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.definitieForm.Denumire) = $event)),
                          label: "Denumire",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_textarea, {
                          modelValue: _ctx.definitieForm.Descriere,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.definitieForm.Descriere) = $event)),
                          label: "Descriere",
                          rows: "2",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.definitieForm.TargetLunarDefault,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.definitieForm.TargetLunarDefault) = $event)),
                          modelModifiers: { number: true },
                          label: "Target Lunar Default",
                          type: "number",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.definitieForm.TipCalcul,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.definitieForm.TipCalcul) = $event)),
                          items: ['Automat', 'Manual'],
                          label: "Tip Calcul",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.definitieForm.SursaDate,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.definitieForm.SursaDate) = $event)),
                          label: "Sursă Date (cod intern)",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.definitieForm.Ordine,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.definitieForm.Ordine) = $event)),
                          modelModifiers: { number: true },
                          label: "Ordine afișare",
                          type: "number",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_switch, {
                          modelValue: _ctx.definitieForm.IsActiv,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.definitieForm.IsActiv) = $event)),
                          label: "Activ",
                          density: "compact",
                          color: _ctx.APP_Color
                        }, null, 8, ["modelValue", "color"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.definitieDialog = false))
                }, {
                  default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
                    _createTextVNode("Anulare", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: _ctx.APP_Color,
                  loading: _ctx.savingDefinitie,
                  onClick: _ctx.saveDefinitie
                }, {
                  default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                    _createTextVNode("Salvare", -1)
                  ]))]),
                  _: 1
                }, 8, ["color", "loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.agentDialog,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.agentDialog) = $event)),
      "max-width": "480"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.agentForm.ID ? 'Editare' : 'Adăugare') + " Rol Agent", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { dense: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.agentForm.Utilizator,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.agentForm.Utilizator) = $event)),
                          label: "Username",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.agentForm.TipAgent,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.agentForm.TipAgent) = $event)),
                          items: ['Hunter', 'Farmer'],
                          label: "Tip Agent",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.agentForm.DataStart,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.agentForm.DataStart) = $event)),
                          label: "Data Start",
                          type: "date",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.agentForm.DataEnd,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.agentForm.DataEnd) = $event)),
                          label: "Data End (opțional)",
                          type: "date",
                          density: "compact",
                          variant: "outlined",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.agentDialog = false))
                }, {
                  default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                    _createTextVNode("Anulare", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: _ctx.APP_Color,
                  loading: _ctx.savingAgent,
                  onClick: _ctx.saveAgent
                }, {
                  default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                    _createTextVNode("Salvare", -1)
                  ]))]),
                  _: 1
                }, 8, ["color", "loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.targetDialog,
      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.targetDialog) = $event)),
      "max-width": "480"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.targetForm.ID ? 'Editare' : 'Adăugare') + " Target", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { dense: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.targetForm.Utilizator,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.targetForm.Utilizator) = $event)),
                          label: "Username",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.targetForm.KPIDefinitieID,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.targetForm.KPIDefinitieID) = $event)),
                          items: _ctx.definitii,
                          "item-title": "Denumire",
                          "item-value": "ID",
                          label: "KPI",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.targetForm.An,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.targetForm.An) = $event)),
                          modelModifiers: { number: true },
                          label: "An",
                          type: "number",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.targetForm.Luna,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.targetForm.Luna) = $event)),
                          items: _ctx.luni,
                          "item-title": "label",
                          "item-value": "value",
                          label: "Lună",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      sm: "4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.targetForm.Target,
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.targetForm.Target) = $event)),
                          modelModifiers: { number: true },
                          label: "Target Override",
                          type: "number",
                          density: "compact",
                          variant: "outlined"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.targetDialog = false))
                }, {
                  default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                    _createTextVNode("Anulare", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: _ctx.APP_Color,
                  loading: _ctx.savingTarget,
                  onClick: _ctx.saveTarget
                }, {
                  default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                    _createTextVNode("Salvare", -1)
                  ]))]),
                  _: 1
                }, 8, ["color", "loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}